import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Features, Team, Banner, WhyChooseUs, Process, Pricing, CaseSection, Partners, Order } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <WhyChooseUs /> {/* Why Choose Us section */}
      <Process /> {/* Process section */}
      <Banner /> {/* Banner Section */}
      <Pricing /> {/* Pricing section */}
      <Order /> {/* Order section */}
      <CaseSection /> {/* Case Studies Section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Partners /> {/* Partners Slider */}
    </div>
  )

}

export default HomePage;